export { default as NikoOrderingDoctorListTemplate } from './NikoOrderingDoctorListTemplate';
